"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookYourDelsonService() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252591" id="piesemotopromotional" className="bg-white text-foreground pt-16 pb-24 lg:pt-24 lg:pb-32 border-t border-border">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-20 max-w-2xl">
          <h2 className="text-2xl font-default font-bold tracking-tighter uppercase text-foreground ![margin:0px_30px_24px_0px] md:text-5xl lg:text-6xl">
            PIESE MOTO
          </h2>

          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-xl leading-relaxed">
            Intră pe link pentru a descoperi magazinul nostru online de piese
            moto.
          </p>
        </div>

        <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-8 py-6 font-default uppercase text-base tracking-widest h-auto font-black shadow-xl transition-transform hover:scale-105">
          <Link to="/HomePage">Vezi Magazinul Online</Link>
        </Button>
      </div>
    </section>;
}